<template>
  <split-screen>
    <template v-slot:left>
      <div class="pb-6">
        <div class="mb-3 md:pr-14">
          <div v-html="content[`home_${lang}`]" />
        </div>

        <div v-if="live" class="md:hidden mb-12">
          <a :href="content.livestream_link" target="_blank"><span class="border-black border px-6 py-2 inline-block mb-2 rounded-full"><span class="bg-red-600 rounded-full h-5 w-5 inline-block mr-3 pulse"></span>WATCH LIVE NOW</span><br/>
          {{ content.livestream_title }}</a>
        </div>

        <div class="flex items-center mb-6">
          <BaseCircle class="inline mr-3 h-6" />&nbsp;<router-link to="/calendar"><span v-if="lang === 'en'">View Calendar Archive</span><span v-else>Programme complet</span></router-link>
        </div>

        <event-list v-if="events" prefix="home" :events="upcomingEvents.slice(0,2)" />
        <div class="mt-3 mb-12 flex"><div class="w-1/6"></div></div>
        <div v-if="content" class="md:hidden install-images w-full" v-html="installImages" />
      </div>
    </template>
    <template v-slot:right>
      <Live v-if="live" />
      <EventDetail v-else-if="events && currentEvent" :event="currentEvent" />
      <div v-else>
        <div v-if="content" class="install-images p-12 mt-16" v-html="installImages" />
      </div>
    </template>
  </split-screen>
</template>

<script>
import 'lazysizes'
import { mapState } from 'vuex'
import { isAfter, isToday } from 'date-fns'
import SplitScreen from '@/views/SplitScreen'
import Live from '@/components/Live'
import EventList from '@/components/EventList'
import EventDetail from '@/components/EventDetail'

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  components: {
    EventDetail,
    EventList,
    Live,
    SplitScreen
  },
  computed: {
    ...mapState([
      'content',
      'events',
      'lang'
    ]),
    currentEvent () {
      if (this.$route.params.date && this.$route.params.slug) {
        return this.$store.getters.getCurrentEvent(this.$route.params.date, this.$route.params.slug)
      } else {
        return false
      }
    },
    live () {
      return this.content.livestream_active === "true"
    },
    upcomingEvents () {
      return this.events.filter(x => {
        return (isToday(new Date(x.date), new Date()) || isAfter(new Date(x.date), new Date()))
      })
    },
    installImages () {
      if (this.content) {
        return this.content.install_images.join('')
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="stylus">
  .cosmo-gif
    background: url('../assets/cosmopolis-2.gif')
    background-repeat: no-repeat
    background-size: cover
    background-position: center

  video
    mix-blend-mode: multiply
    pointer-events: none

  .blur
    filter: blur(0)
    animation: blur 5s infinite

  @keyframes blur
    0%, 100%   { filter: blur(0); }
    50% { filter: blur (40px); }

  h2
    margin 4em

  .install-images
    img
      @apply w-full mb-12
</style>
